export default __webpack_public_path__ + "img/usersshared.a3f1d717.svg";